'use client';

import { useTranslations } from 'next-intl';
import { FilteredCounter, ListPageFilterPanel } from '@terra/ui-design-system';
import { ListPageDateRangeFilter } from '../../common/ListPageDateRangeFilter';

type ReportsFilterPanelProps = {
  createdStartDate: Date | null;
  createdEndDate: Date | null;
  onCreatedStartDateChange: (date: Date | null) => void;
  onCreatedEndDateChange: (date: Date | null) => void;
  hasActiveFilters: boolean;
  onClear: () => void;
  showFilteredCounter: boolean;
  filteredCount: number;
  totalCount: number;
};

export function ReportsFilterPanel({
  createdStartDate,
  createdEndDate,
  onCreatedStartDateChange,
  onCreatedEndDateChange,
  hasActiveFilters,
  onClear,
  showFilteredCounter,
  filteredCount,
  totalCount,
}: ReportsFilterPanelProps) {
  const tFilters = useTranslations('proxy.filters');
  const tEntities = useTranslations('proxy.filteredCounter.entities');

  return (
    <ListPageFilterPanel
      isClearDisabled={!hasActiveFilters}
      onClear={onClear}
      trailing={
        showFilteredCounter ? (
          <FilteredCounter
            filteredCount={filteredCount}
            totalCount={totalCount}
            entityLabel={tEntities('reports')}
          />
        ) : null
      }
    >
      <ListPageDateRangeFilter
        label={tFilters('createdAt')}
        startDate={createdStartDate}
        endDate={createdEndDate}
        onStartDateChange={onCreatedStartDateChange}
        onEndDateChange={onCreatedEndDateChange}
      />
    </ListPageFilterPanel>
  );
}
